<template>
    <router-view />
</template>

<script>
export default {
    inject: ['reload'],
    data() {
        return {}
    },
    created() {
        this.$nextTick(() => {
            if (this.$route.path === '/activity') {
                this.$router.replace({
                    path: '/activity/raffle'
                })
            }
        })
    },
    mounted() {
        this.$nextTick(() => {})
    },
    methods: {}
}
</script>

<style scoped lang="less"></style>
